export const headerData = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/cover_efc7f2ee-9fed-44ce-a7fa-942fd2dc43e7.jpg?v=1604295118',
    altText: 'OBERBEKLEIDUNG',
    title: `OBERBEKLEIDUNG`,
    cap_image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/covermaa_43e8b4b1-d678-4f02-a514-a7236d1c25b5.jpg?v=1604295120',
  },
];

export const w1Data = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/img2_8af519ed-c614-4bae-894c-0b2f2a7e9072.jpg?v=1604470116',
    altText: 'blazer-mit-ellbogen-patches-schwarz',
    handle: '/products/blazer-mit-ellbogen-patches-schwarz',
    btn: 'Jetzt entdecken',
    description:
      'In dieser Saison locken uns elegante, klassische Mäntel und Blazer an. Sie können mit dem mühelosen aber stylischen Mantel alltäglich Luxus genießen.',
    style: ' c-hide',
    w1Child: [
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item3_44b54c35-5aa8-4d39-938c-9248e0971e21.jpg?v=1604295119',
        altText: 'caban-mantel-mit-stehkragen-rum-rosine',
        btn: 'Jetzt entdecken',
        handle: '/products/caban-mantel-mit-stehkragen-rum-rosine',
        style: ' c-hide',
      },
      {
        image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item4.jpg?v=1604295120',
        altText: 'schalkragen-mantel-kakao',
        btn: 'Jetzt entdecken',
        handle: '/products/schalkragen-mantel-kakao',
        style: ' c-hide',
      },
    ],
    w1Child2: [
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item5_e1adf3f1-4287-40e7-8dee-cfc2e8ff9b69.jpg?v=1604470115',
        altText: 'blazer-mit-ellbogen-patches-schwarz',
        btn: 'Jetzt entdecken',
        handle: '/products/blazer-mit-ellbogen-patches-schwarz',
        style: ' c-hide',
      },
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item6_ca228b01-db23-49f1-95d4-aea19376b50a.jpg?v=1604470116',
        altText: 'wendemantel-mit-drapiertem-kragen-kamel',
        btn: 'Jetzt entdecken',
        handle: '/products/wendemantel-mit-drapiertem-kragen-kamel',
        style: ' c-hide',
      },
    ],
  },
];
export const w2Data = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item7_1c86254f-4d52-455f-b97a-3d7658fe9ca1.jpg?v=1604470115',
    altText: 'klassischer-zweiseitiger-mantel',
    handle: '/products/klassischer-zweiseitiger-mantel',
    btn: 'Jetzt entdecken',
    description: `Alles hat zwei Seiten. Unser Wendemantel ist ein cleverer Weg, um das Beste aus einem Mantel herauszuholen.`,
    style: ' c-hide',
    w2Child: [
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item8_3bf4c645-fe5d-4f41-a12a-b501c1751cab.jpg?v=1604470118',
        altText: 'langer-zweiseitiger-wendemantel-tradewinds',
        handle: '/products/langer-zweiseitiger-wendemantel-tradewinds',
        btn: 'Jetzt entdecken',
        style: ' c-hide',
      },
    ],
  },
];
export const w3Data = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item9_16089d1c-530c-4927-97f7-98e48218052c.jpg?v=1604470115',
    altText: 'mantel-mit-eingekerbtem-reverskragen-taupe',
    handle: '/products/mantel-mit-eingekerbtem-reverskragen-taupe',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item11_fb85517f-3200-420e-b03f-aece54855939.jpg?v=1604470115',
    altText: 'mantel-mit-eingekerbtem-reverskragen-rot',
    handle: '/products/mantel-mit-eingekerbtem-reverskragen-rot',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' m-grid',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item10_9102bc18-e7ea-4f24-b7da-51c2092aeb71.jpg?v=1604470115',
    altText: 'klassischer-reverskragen-mantel-mitternacht',
    handle: '/products/klassischer-reverskragen-mantel-mitternacht',
    btn: 'Jetzt entdecken',
    style: ' c-hide',
    style2: ' img-box-bottom',
  },
];

export const w8Data = [
  {
    title: 'EWIGE BLAZER',
    w8Child: [
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item12_5dd02f58-d030-4692-9851-68d1a8914fba.jpg?v=1604295120',
        altText: 'blazer-mit-austeigendem-reverskragen-traubenshake',
        handle: '/products/blazer-mit-austeigendem-reverskragen-traubenshake',
        btn: 'Jetzt entdecken',
        style2: ' pad-right-100',
        style: ' c-hide',
      },
      {
        image:
          'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/item13_ffb8d788-9b80-4f0e-bb31-d8cd84ef54a8.jpg?v=1604470116',
        altText: 'klassischer-reverskragen-mantel-beige',
        handle: '/products/klassischer-reverskragen-mantel-beige',
        btn: 'Jetzt entdecken',
        style2: ' pad-left-100',
        style: ' c-hide',
      },
    ],
  },
];
